import { useState } from 'react'
import { useDispatch } from 'react-redux'
import { setData, setPex, setGroup, setLoggedIn } from '../store/userSlice.js'
import axiosInstance from '../util/axios.js'

export default function useAuth() {
	// Initialize token from localStorage if available
	const [token, setToken] = useState(
		() => localStorage.getItem('jwtToken') || null
	)
	const dispatch = useDispatch()

	const clearUserData = () => {
		console.log('clearUserData')
		dispatch(setData({}))
		dispatch(setPex({}))
		dispatch(setGroup({}))
		dispatch(setLoggedIn(false))

		localStorage.removeItem('jwtToken')
		setToken(null)
	}

	const login = (email, password) => {
		return new Promise((resolve, reject) => {
			axiosInstance
				.post('api/auth', { email, password })
				.then((data) => {
					localStorage.setItem('jwtToken', data.token)
					setToken(data.token)
					dispatch(setLoggedIn(true))

					resolve(true)
				})
				.catch((err) => {
					clearUserData()

					if (err.response && err.response.status === 401) {
						resolve(false)
					} else {
						reject(err)
					}
				})
		})
	}

	const logout = () => {
		localStorage.removeItem('jwtToken')
		setToken(null)
		clearUserData()
	}

	return [token, login, logout]
}
